export const ROUTES = {
  DASHBOARD: (lng: string = 'en') => `/${lng}`,
  ANALYTICS: (lng: string = 'en') => `/${lng}/analytics`,
  LOGIN: (lng: string = 'en') => `/${lng}/login`,
  SIGNUP: (lng: string = 'en') => `/${lng}/signup`,
  CHAT: (lng: string = 'en') => `/${lng}/chat`,
  TOPICS: (lng: string = 'en') => `/${lng}/topics`,
  DATASOURCES: (lng: string = 'en') => `/${lng}/datasources`,
  SETTINGS: (lng: string = 'en') => `/${lng}/settings`,
  ERRORS: (lng: string = 'en') => `/${lng}/errors`,
  NOTIFICATIONS: (lng: string = 'en') => `/${lng}/notifications`,
  BILLING: (lng: string = 'en') => `/${lng}/billing`,
  WORKSPACES: (lng: string = 'en') => `/${lng}/workspaces`,
  ASSETS: (lng: string = 'en') => `/${lng}/assets`,
  PLAN: '/plan',
  AUTH_CALLBACK: (lng: string = 'en') => `/${lng}/auth/callback`,
  AUTH_CONFIRM: (lng: string = 'en') => `/${lng}/auth/confirm`,
  RESET_PASSWORD: (lng: string = 'en') => `/${lng}/reset-password`,
  ADMIN: (lng: string = 'en') => `/${lng}/admin`,
};
